import React, { useState } from 'react';
import BulkUploadModal from './BulkUploadModal';

const CustomerImport = () => {
  const [modalOpen, setModalOpen] = useState(false);

  return (
    <div className="p-4">
      <button
        onClick={() => setModalOpen(true)}
        className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
      >
        Bulk Upload Items
      </button>

      {modalOpen && <BulkUploadModal onClose={() => setModalOpen(false)} />}
    </div>
  );
};

export default CustomerImport;